"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    SYNC_COMPLETE: 'complete',
    SYNC_BASIC_INFO: 'basic_info',
    SYNC_RELATIONS: 'user_relationships',
    SYNC_USER_ROLE: 'user_role',
    SYNC_TUTOR_SUBJECT: 'tutor_subject',
    SYNC_KEY_CONTACT: 'primary_key_contact',
    SYNC_PAYMENT_INFO: 'payment_info',
    SYNC_PREALLOCATE_STUDENTS: 'preallocate_students',
    TASK_RECORDING_REDRIVE: 'recording_redrive',
    TASK_RECORDING_ARCHIVE: 'recording_archive',
};
//# sourceMappingURL=messageModes.js.map